module.exports = __webpack_public_path__ + "img/memberstatus.11c4bb15.png";